import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useFetcher } from 'react-router';

import Button from 'honeydew/Button';
import TextField from 'honeydew/TextField';
import profileStyles from 'pages/account/Profile/styles';

export default function Name({ subscription }) {
    const address = subscription?.shippingAddr ?? {};
    const [isEditing, setIsEditing] = useState(false);

    return isEditing ? (
        <div className={profileStyles.editContainer}>
            <Form subscriptionID={subscription?.id} address={address} setIsEditing={setIsEditing} />
            <button type="button" className={profileStyles.cancel} onClick={() => setIsEditing(false)}>
                Cancel
            </button>
        </div>
    ) : (
        <div className={profileStyles.displayContainer}>
            <div>
                <h4 className="font-grotesk-bold">Name</h4>
                {subscription?.id && (
                    <p className="mt-10">
                        {address?.firstName} {address?.lastName}
                    </p>
                )}
            </div>
            <button className={profileStyles.edit} type="button" onClick={() => setIsEditing(true)}>
                Edit
            </button>
        </div>
    );
}

Name.propTypes = {
    subscription: PropTypes.shape({}),
};

Name.defaultProps = {
    subscription: {},
};

function Form({ address, setIsEditing, subscriptionID }) {
    const fetcher = useFetcher();
    const { firstName = '', lastName = '', ...addressFields } = address;
    const isBusy = fetcher.state !== 'idle' && !fetcher.data?.error;

    useEffect(() => {
        if (fetcher.data?.success && fetcher.state === 'idle') {
            setIsEditing(false);
        }
    }, [fetcher]);

    return (
        <fetcher.Form action="." method="post" className="block grow">
            <fieldset className="flex flex-col gap-5">
                <TextField
                    autoComplete="off"
                    autoCorrect="off"
                    defaultValue={firstName}
                    error={fetcher?.data?.error}
                    errorMsg={fetcher?.data?.message}
                    label="First name"
                    name="firstName"
                    required
                />
                <TextField
                    autoComplete="off"
                    autoCorrect="off"
                    defaultValue={lastName}
                    error={fetcher?.data?.error}
                    errorMsg={fetcher?.data?.message}
                    label="Last name"
                    name="lastName"
                    required
                />
                <input type="hidden" name="subscriptionID" defaultValue={subscriptionID} />
                {/* NOTE: there is no stand-alone endpoint to update phone number.
                    So we are passing all shipping address fields back to the API in order to update phone number. */}
                {Object.keys(addressFields).map((addressField) => (
                    <input
                        key={addressField}
                        type="hidden"
                        name={addressField}
                        value={addressFields[addressField] ?? ''}
                    />
                ))}
                <Button type="submit" disabled={isBusy} name="_action" value="updateName">
                    {isBusy ? 'Saving...' : 'Save'}
                </Button>
            </fieldset>
        </fetcher.Form>
    );
}

Form.propTypes = {
    address: PropTypes.shape({}),
    subscriptionID: PropTypes.number,
};

Form.defaultProps = {
    address: {},
    subscriptionID: null,
};
